<template>
  <div v-if="hasAccess">
    <page-submenu :links="links" />
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageSubmenu from '@/components/PageSubmenu.vue'

export default {
  name: 'app-dashboard-tracking-employees',
  components: {
    PageSubmenu
  },
  computed: {
    ...mapGetters(['roles']),
    hasAccess () {
      return this.roles.includes('admin') || this.roles.includes('community-manager')
    },
    links () {
      return [
        {
          label: 'Général',
          path: '/app/dashboard/tracking/employees/general',
          roles: ['admin', 'community-manager']
        },
        {
          label: 'Contenus',
          path: '/app/dashboard/tracking/employees/contents',
          roles: ['admin', 'community-manager']
        },
        {
          label: 'Préoccupations',
          path: '/app/dashboard/tracking/employees/concerns',
          roles: ['admin', 'community-manager']
        },
        {
          label: 'Web / application',
          path: '/app/dashboard/tracking/employees/platforms',
          roles: ['admin', 'community-manager']
        }
      ]
    }
  }
}
</script>
